__turbopack_context__.v({
  "bottomWrapper": "cG84hW_bottomWrapper",
  "chatDialog": "cG84hW_chatDialog",
  "disclaimer": "cG84hW_disclaimer",
  "disclaimerLink": "cG84hW_disclaimerLink",
  "emptyState": "cG84hW_emptyState",
  "emptyStateText": "cG84hW_emptyStateText",
  "hidden": "cG84hW_hidden",
  "moreStuffContainer": "cG84hW_moreStuffContainer",
  "qAndAWrapper": "cG84hW_qAndAWrapper",
  "questionTitle": "cG84hW_questionTitle",
  "scrollableWrapper": "cG84hW_scrollableWrapper",
  "sourceWrapper": "cG84hW_sourceWrapper",
  "speechBubble": "cG84hW_speechBubble",
  "topWrapper": "cG84hW_topWrapper",
  "waitingMessage": "cG84hW_waitingMessage",
});
